import { render, staticRenderFns } from "./RelaxOverflow.vue?vue&type=template&id=1cd3d4e7&"
import script from "./RelaxOverflow.vue?vue&type=script&lang=js&"
export * from "./RelaxOverflow.vue?vue&type=script&lang=js&"
import style0 from "./RelaxOverflow.vue?vue&type=style&index=0&id=1cd3d4e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports